import { useLocation } from "react-router-dom";

export const useCurrentApp = (): string => {
  const { pathname } = useLocation();
  return pathname.split("/")[2] || "";
};
